var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNeutralEmoji(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7501 42.4319C3.10961 42.4132 -6.26669 19.7752 6.90108 6.58273C14.7176 -1.56311 28.7827 -1.56442 36.5992 6.58306C49.7668 19.7767 40.3894 42.4142 21.7501 42.4319ZM21.7501 2.23673C11.1658 2.23673 2.55484 10.8477 2.55484 21.432C3.60926 46.8971 39.8947 46.8897 40.9453 21.4318C40.9453 10.8477 32.3344 2.23673 21.7501 2.23673Z",
    fill: "url(#paint0_linear_3889_329)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7501 2.23673C11.1658 2.23673 2.55484 10.8477 2.55484 21.432C3.60926 46.8971 39.8947 46.8897 40.9453 21.4318C40.9453 10.8477 32.3344 2.23673 21.7501 2.23673Z",
    fill: "url(#paint1_linear_3889_329)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8564 14.6676C12.669 14.6676 11.7031 15.6335 11.7031 16.8208C11.8214 19.6774 15.8917 19.6766 16.0096 16.8208C16.0096 15.6334 15.0436 14.6676 13.8564 14.6676Z",
    fill: "#2D2D2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.203 14.6678C28.0157 14.6678 27.0498 15.6337 27.0498 16.8211C27.1681 19.6776 31.2384 19.6768 31.3563 16.8211C31.3563 15.6337 30.3903 14.6678 29.203 14.6678Z",
    fill: "#2D2D2D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9253 30.8599H11.5752C11.0769 30.8599 10.6729 30.4559 10.6729 29.9575C10.6729 29.4592 11.0769 29.0552 11.5752 29.0552H31.9253C33.1164 29.0998 33.1275 30.8101 31.9253 30.8599Z",
    fill: "#2D2D2D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3889_329",
    x1: 3.559,
    y1: 31.9465,
    x2: 39.9232,
    y2: 10.9319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB34D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#ECB64D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EEC04F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F1CC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3D652"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3889_329",
    x1: 3.559,
    y1: 31.9465,
    x2: 39.9232,
    y2: 10.9319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBB34D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#ECB64D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EEC04F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F1CC51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3D652"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralEmoji);
export default __webpack_public_path__ + "static/media/neutral-emoji.d6c41af24dbf8d66f31ec60569f8e9b9.svg";
export { ForwardRef as ReactComponent };